import React, { forwardRef } from 'react';
import { styled } from 'baseui';
const StyledVideoElement = styled<'video', {
  $disablePointerEvents: boolean;
  $brightness: number;
  $contrast: number;
}>('video', ({
  $disablePointerEvents,
  $brightness,
  $contrast
}) => ({
  width: '100%',
  height: '100%',
  pointerEvents: $disablePointerEvents ? 'none' : 'auto',
  filter: `brightness(${$brightness}%) contrast(${$contrast}%)`
}));
type PropsT = {
  id: string;
  src: string;
  videoType: string;
  disablePointerEvents: boolean;
  brightness: number;
  contrast: number;
};
function _StyledVideo({
  id,
  src,
  videoType,
  disablePointerEvents,
  brightness,
  contrast,
  ...otherVideoProps
}: PropsT, ref: React.Ref<HTMLVideoElement>) {
  return <StyledVideoElement id={id} data-testid="video-player" key={id} src={src} ref={ref} $disablePointerEvents={disablePointerEvents} $brightness={brightness} $contrast={contrast} {...otherVideoProps}>
      <source src={src} type={videoType} />
    </StyledVideoElement>;
}
export const StyledVideo = forwardRef(_StyledVideo);